module.exports = "/fonts/logo-sobatpajak-light-26fe423ab3c1cf5e9ffadda3a9cb64cc.svg";